import React from 'react';
import { Modal } from './ui/Modal';

interface ExtraPaymentsWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ExtraPaymentsWarningModal: React.FC<ExtraPaymentsWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-xl font-semibold leading-6 text-gray-900">
            Warning: Manual Edits Will Be Lost
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              You have made manual edits to the Extra Payments in the amortization table. 
              Changing the Recurring Extra Payments will overwrite these manual edits.
              Are you sure you want to proceed?
            </p>
          </div>
          <div className="mt-4 flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex flex-1 justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex flex-1 justify-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}; 